<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">择机下单</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>用户余额</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';

export default {
  name: 'orderTaskUserAmountRecords',
  data() {
    return {
      params: {
        foundationId: '',
        userId: ''
      }
    };
  },
  components: {
    List
  },
  methods: {
    ...mapActions('orderTaskUserAmountRecord', ['getRecords']),
    handleSearch() {
      this.getList();
    },
    getList(data = {}) {
      this.getRecords({
        ...this.params,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
